import React from "react";
import InvoiceField from "../component/InvoiceFiled";

const ExcelForm = ({ data = {}, onUpdate = () => {}, onSave = () => {} }) => {

  const updateField = (key, value) => {
    onUpdate(key, value);
  };

  const updateItem = (index, key, value) => {
    const rows = [...(data.items || [])];
    rows[index] = { ...rows[index], [key]: value };

    const qty = parseFloat(rows[index].qty || 0);
    const rate = parseFloat(rows[index].rate || 0);
    if (!isNaN(qty) && !isNaN(rate)) {
      rows[index].amount = (qty * rate).toFixed(2);
    }

    onUpdate("items", rows);
  };

  const addItem = () => {
    const rows = [...(data.items || []), { desc: "", subDesc: "", qty: "", rate: "", amount: "0.00" }];
    onUpdate("items", rows);
  };

  const removeItem = (index) => {
    const rows = [...(data.items || [])];
    rows.splice(index, 1);
    onUpdate("items", rows);
  };

  return (
    <div className="space-y-4">
      <h3 className="font-bold text-lg text-[#003399] border-b pb-2 uppercase tracking-wide">Excel Inventory Details</h3>

      <div className="grid grid-cols-2 gap-4">
        <InvoiceField 
          label="Invoice #" 
          value={data?.invoiceNumber || ""} 
          onChange={(v) => updateField("invoiceNumber", v)} 
          required 
        />
        <InvoiceField 
          label="Due Date" 
          type="date" 
          value={data?.dueDate || ""} 
          onChange={(v) => updateField("dueDate", v)} 
        />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <InvoiceField 
          label="Tax Rate (%)" 
          type="number" 
          value={data?.taxRate || "5"} 
          onChange={(v) => updateField("taxRate", v)} 
        />
        <InvoiceField 
          label="Terms" 
          type="dropdown" 
          value={data?.terms || "Due on Receipt"} 
          options={["Due on Receipt", "Net 15", "Net 30"]} 
          onChange={(v) => updateField("terms", v)} 
        />
      </div>

      <div className="pt-4 border-t">
        <InvoiceField 
          label="Ship To Address" 
          type="description" 
          value={data?.shipToAddress || ""} 
          onChange={(v) => updateField("shipToAddress", v)} 
          rows="2" 
        />
      </div>

      <div className="pt-4 border-t">
        <h4 className="text-xs font-bold text-gray-400 mb-2 uppercase">Items</h4>
        {(data.items || []).map((item, idx) => (
          <div key={idx} className="grid grid-cols-5 gap-2 mb-2 items-end">
            <InvoiceField
              label="Item Name"
              value={item.desc || ""}
              onChange={(v) => updateItem(idx, "desc", v)}
            />
            <InvoiceField
              label="Description"
              value={item.subDesc || ""}
              onChange={(v) => updateItem(idx, "subDesc", v)}
            />
            <InvoiceField
              label="Qty"
              type="number"
              value={item.qty || ""}
              onChange={(v) => updateItem(idx, "qty", v)}
            />
            <InvoiceField
              label="Rate"
              type="number"
              value={item.rate || ""}
              onChange={(v) => updateItem(idx, "rate", v)}
            />
            <InvoiceField
              label="Amount"
              type="number"
              value={item.amount || "0.00"}
              disabled
            />

            <button
              type="button"
              onClick={() => removeItem(idx)}
              className="text-red-500 text-xs mt-2"
            >
              Remove
            </button>
          </div>
        ))}

        <button
          type="button"
          onClick={addItem}
          className="text-[#003399] text-sm mt-2"
        >
          + Add Item
        </button>
      </div>

      <div className="pt-4 border-t">
        <button
          type="button"
          onClick={() => onSave(data)}
          className="bg-[#003399] text-white px-4 py-2 rounded text-sm font-bold"
        >
          Save Invoice
        </button>
      </div>
    </div>
  );
};

export default ExcelForm;
